import React from "react";
import Router from "./Router";

export default function Layout() {
  return (
    <React.Fragment>
      <Router />
    </React.Fragment>
  );
}
